<template>
<div class="card role">
  <div class="card-header bg-transparent">
    <div class="row align-items-center">
        <div class="col-md-3">
          <h3>Users</h3>
        </div>
        <div class="col cyanb">
          <i class="fas fa-user-cog"></i>
          <span>{{usersCount}}</span>
          Users
        </div>
        <div class="text-right" v-if="isAdmin || isSuperAdmin">
          <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i></a>
        </div>
    </div>
  </div>
</div>
</template>
<script>
// import cognitoService from '@/cognito/cognitoidentityserviceprovider.js';
import config from "@/config";
import authService from "@/authService";
//import axios from "axios";

export default {
  name: "users",
  data() {
    return {
      usersCount : 0,
      accessToken: null,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      isAdmin: false
    };
  },
  methods: {
    navigateListPage(){
      window.location.href = "/bidside/admin-users";
    },
    getUserList(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +"/user/counts",
            auth
        )
        .then(result => {
          this.usersCount = result.data.active;
          this.loading = false;
          
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        this.error = err;
      } else {
        this.accessToken = result;
        this.getUserList();
      }
    });

    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        
        this.roleArray = role.map(item => {return  item.split("-")[1]});

        this.roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
        this.roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
        this.roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
        this.roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
      }
    });
  }
};
</script>